export const formatDate = (date: string, options?: Intl.DateTimeFormatOptions) => {
  return Intl.DateTimeFormat('en-US', { timeZone: 'UTC', ...options }).format(new Date(date));
};
